<template>
  <div class="downindex">
    <img src="../../assets/images/download/logo.png" class="logo" alt />
    <p class="title_h1">家庭中医馆</p>
    <p class="title_h2">咨询&nbsp;&nbsp;自诊&nbsp;&nbsp;购物&nbsp;&nbsp;养生</p>
    <p class="about_title">关于此应用</p>
    <p class="about_content">
      家庭中医馆，让每个居民有一个家庭医生，提供医疗级用药，让健康触手可及！
      <br />1、可在线咨询，回复速度快，全程跟踪照护。
      <br />2、特有用药处方，效果好，恢复更快。
      <br />3、送药到家，快捷配送，满额包邮。
      <br />4、药品真、药品全，与国内外知名企业合作，提供优质低价的放心药。
      <br />5、健康档案、记录用药、病历，随时查看，看病就医有据可循。
    </p>
    <div class="download" @click="checkapp">
      立即下载
    </div>
    <p class="openqr" @click="isshowqrcode=true">
      <img src="../../assets/images/download/qrcode.png" alt="">
      查看二维码
    </p>
    <!-- 提示右上角 -->
    <div class="right_top" v-show="isshowalert">
      <img src="../../assets/images/download/guide.png" class="guide" alt="">
      <img src="../../assets/images/download/close_guide.png" @click="isshowalert=false" class="close_guide" alt="">
      <!-- <img class="rt_img" src="../../assets/images/download/download.png" alt />
      <p class="rt_text">
        请点击右上角,
        选择使用浏览器<br />打开即可完成下载哦~
      </p> -->
    </div>
    <!-- 提示 -->
    <div class="phone_bg" v-show="isshowalert"></div>
    <div class="phone_bg" v-show="isshowqrcode" @click="isshowqrcode=false"></div>
    <!-- <div class="alert_content" v-show="isshowalert">
      <p class="alert_title">
        温馨提示
        <span @click="isshowalert=false">取消</span>
      </p>
      <p class="alert_text">您还没有家庭中医馆APP暂时不能查看优惠券，去点击下载</p>
    </div> -->
    <!-- 弹窗 -->
    <div class="qrcode_content" v-show="isshowqrcode" >
      <div class="qrcode" v-if="isapp != 'IOS'"></div>
      <div class="qrcode2" v-else></div>
      <p>使用浏览器扫一扫，即可下载app</p>
    </div>
  </div>
</template>
<script>
import CallApp from "callapp-lib";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isshowalert: false,
      isshowqrcode:false,
      isapp :''
    };
  },
  created() {
    // this.$nextTick(function() {
    //   this.qrcode();
    // });
  },
  mounted() {
    this.isapp = this.$appUtils.isApp()
  },
  methods: {
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 273, // 设置宽度
        height: 273, // 设置高度
        text: "http://d.firim.info/q5l2"
      });
    },
    checkapp() {
      if (this.iswechat()) {
      //   // this.isshowsuccess = false;
        this.isshowalert = true;
      } else {
        // alert("go app");
        this.openApp();
      }
    },
    iswechat() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    isIOS() {
      var u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    openApp() {
      if(this.isapp == 'ios'){
        window.open('https://www.pgyer.com/Cno0')

      }else {
        window.open('http://d.firim.pro/q5l2')

      }
    },
  },
};
</script>
<style lang="scss">
.downindex {
  width: 100%;
  // height: 100%;
  color: #333;
  box-sizing: border-box;
  padding-top: 10px;
  padding: 10px 15px 0px 15px;
  .logo {
    width: 72px;
    height: 72px;
    display: block;
    margin: 0 auto;
  }
  .title_h1 {
    font-family: PingFang-SC-Heavy;
    font-weight: 800;
    font-size: 17px;
    margin-top: 20px;
    text-align: center;
  }
  .title_h2 {
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    font-size: 14px;
    margin-top: 9px;
    text-align: center;
  }
  .about_title {
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    margin-top: 35px;
  }
  .about_content {
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    margin-top: 18px;
  }
  .download {
    width: 155px;
    height: 43px;
    border-radius: 4px;
    background: #ac4b38;
    text-align: center;
    line-height: 43px;
    color: #fff;
    font-size: 17px;
    margin: 0 auto;
    margin-top: 110px;
  }
  .alert_content {
    height: 167px;
    color: #333;
    .alert_title {
      text-align: center;
      margin-top: 27px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      position: relative;
      font-size: 18px;
      span {
        position: absolute;
        top: 2px;
        right: 25px;
        color: #ac4b38;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .alert_text {
      width: calc(100% - 60px);
      margin: 0 auto;
      margin-top: 28px;
    }
  }
  .right_top {
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 10;
    .guide{
      width: 100%;
    }
    .close_guide{
      width: 100px;
      display: block;
      margin: 0 auto;
      margin-top: 30px;
    }
    .rt_img {
      width: 57px;
      height: 45px;
      position: absolute;
      right: 10px;
      top: 0;
    }
    .rt_text {
      margin-top: 60px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
    }
  }
  .phone_bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.6);
  }
  .qrcode_content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    // width: calc(100% - 75px);
    width: 300px;
    background: #fff;
    border-radius: 10px;
    border: 1px solid transparent;
    padding-top: 13px;
    .qrcode{
      width: 273px;
      height: 273px;
      margin: 0 auto;
      background: url('../../assets/images/download/anzhuo.png') no-repeat center center;
      background-size: 100% 100%;
    }
    .qrcode2{
      width: 273px;
      height: 273px;
      margin: 0 auto;
      background: url('../../assets/images/download/ios.png') no-repeat center center;
      background-size: 100% 100%;
    }
    p{
      margin-top: 12px;
      margin-bottom: 15px;
      text-align: center;
      font-size: 14px;
    }
  }
  .openqr{
    width: fit-content;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    font-size: 14px;
    margin: 0 auto;
    margin-top: 25px;
    margin-bottom: 30px;
    img{
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/download/download.vue